import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { PairingButton } from 'src/Libs/flow/components'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { TextField } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import { useDevicePairing } from '../../hooks'

export const GeneralData: React.FC<{ storageIndex: number }> = ({ storageIndex }) => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const { control } = useInstallationForm()
  const storage = useWatch({ control, name: `storageDevices.${storageIndex}` })

  const { canPair, handlePairing } = useDevicePairing(storage, storageIndex)

  const buttonTextPaired = storage?.pairingId ? t('common.replace') : t('common.pair')
  const buttonText = storage?.deviceId ? t('common.edit') : buttonTextPaired

  return (
    <Box id={storage?.navigationId ?? ''} sx={{ display: 'grid' }}>
      <Typography variant="h2" mb={2}>
        {t('installation.generalData.generalData')}
      </Typography>
      <SettingsBox
        title={t('common.name')}
        suffix={<TextField name={`storageDevices.${storageIndex}.name`} label={t('common.name')} disabled={!canEdit} />}
      />
      <SettingsBox
        title={t('productEditor.pairingEditor.pairingID.storage')}
        suffix={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 2,
              width: {
                xs: '100%',
                sm: 'auto',
              },
            }}
          >
            <TextField name={`storageDevices.${storageIndex}.pairingId`} label={t('productEditor.pairingEditor.pairingID.storage')} disabled />
            <PairingButton fullWidth onClick={handlePairing} icon={storage?.pairingId ? 'transfer' : 'link'} disabled={!canPair || !canEdit}>
              {buttonText}
            </PairingButton>
          </Box>
        }
      />
    </Box>
  )
}
